import { MessageService } from './../../../../structure/service/message.service';
import { JwtService } from './../../../../structure/service/auth/jwt.service';
import { Router } from '@angular/router';
import { MessageInfra } from 'src/app/structure/message/message-infra';
import { EnumTipoMensagem } from './../../../../structure/enum/enum-infra';
import { Component } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public  router: Router,
    private jwtService: JwtService,
    private messageService: MessageService
  ){}

  public showNotification = false;
  public showMessage = false;

  // This is for Notifications
  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Novo Sistema',
      subject: 'Esse é o novo sistema Cecam!',
      time: '9:30 AM'
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'Todos os Dias',
      subject: 'Aviso de Atualização',
      time: '9:10 AM'
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'Configurações',
      subject: 'Você pode customizar o template do sistema.',
      time: '9:08 AM'
    },
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  sair()
  {
      this.jwtService.destroyToken();
      this.messageService.showNotify(MessageInfra.SessaoEncerrada, EnumTipoMensagem.Alerta);
      this.router.navigateByUrl('/authentication/login');
  }

  imagemUsuario()
  {
    var imagemUsuario = this.jwtService.getImagemUsuario();
    return imagemUsuario
  }

  edicaoUsuario()
  {
    var usuario = this.jwtService.getUsuarioDadosJSON();
    this.router.navigateByUrl('/usuarios/usuario/'+usuario.Id);
  }

  onDataHoje()
  {
    var data = new Date();
    return data.toLocaleDateString('pt-br', {timeZone: 'UTC' });
  }

}
